<ol cdkScrollable>
    <li *ngFor="let item of data; let index = index; let count = count"
        [templateStore]="{ context: rowContext(item, index, count) }"
        #store="templateStore"
        (click)="navigateToRow(item)" (tap)="navigateToRow(item)"
    >
        <header *ngIf="headerTemplate">
            <ng-container *ngTemplateOutlet="headerTemplate; context: store.context"></ng-container>
        </header>
        <section>
            <ng-container *ngTemplateOutlet="template; context: store.context"></ng-container>
        </section>
        <footer>
            <div data-pagination>
                <strong>{{ index + 1 }}</strong> / {{ count }}
            </div>
            <div data-content>
                <ng-container *ngIf="footerTemplate">
                    <ng-container *ngTemplateOutlet="footerTemplate; context: store.context"></ng-container>
                </ng-container>
            </div>
            <div data-navigation *ngIf="isNavigable">
                <mat-icon>arrow_forward</mat-icon>
            </div>
        </footer>
    </li>
    <li data-spacer></li>
</ol>
